export const COMMON_PRIVATE = 'f6e512a3c259e5f9af981d7f99d245aa5bc52fe448495e0b0dd56e8406be6f71';
export const APP_NAME = process.env.REACT_APP_HTML_TITLE;
